import 'css-chunksrc/client/scenes/notifications/notification/addedToTask/styles.scss';export default {
  "notification": "_notification_1q0b1_1",
  "header": "_header_1q0b1_8",
  "date": "_date_1q0b1_18",
  "main": "_main_1q0b1_24",
  "author": "_author_1q0b1_28",
  "avatar": "_avatar_1q0b1_38",
  "authorName": "_authorName_1q0b1_43",
  "text": "_text_1q0b1_49",
  "content": "_content_1q0b1_56",
  "mention": "_mention_1q0b1_63",
  "task": "_task_1q0b1_67"
};